var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMeat(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 42,
    viewBox: "0 0 44 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_641_280)",
    filter: "url(#filter0_d_641_280)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.1492 28.3165C25.8877 28.261 24.4512 27.1706 23.6245 26.1764C22.8837 25.2859 22.5585 24.0612 22.1823 22.6432C21.6585 20.6703 21.0064 18.2148 18.9622 15.9541C16.9352 13.7129 14.4287 12.7368 12.2171 11.876C8.95252 10.6049 7.62757 9.97345 7.62757 7.0791C7.62757 6.7627 7.62867 6.07687 8.21314 5.28723C5.62064 6.99835 3.96061 9.15524 4.00071 11.5255C4.10453 17.6944 10.4997 16.5578 14.3149 20.7771C18.3497 25.239 15.1837 29.5788 23.3575 32.752C27.6518 34.4191 34.8459 32.2139 38.4533 23.3067C38.3643 23.4193 32.9154 28.4332 28.1492 28.3165Z",
    fill: "#EA3942"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.9994 16.8476C39.9994 24.3085 33.7213 31.9854 25.6183 30.3567C16.9984 28.6242 20.3751 23.178 16.3403 18.7164C12.5248 14.4968 5.71875 16.1085 5.71875 9.4651C5.71875 3.44596 16.1379 1.83866 25.6183 3.33857C33.4631 4.57975 39.9994 9.38682 39.9994 16.8476Z",
    fill: "#F3E8D7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.7706 6.97144C36.1566 8.89761 36.9635 11.1899 36.9635 13.8102C36.9635 21.271 30.6854 28.9479 22.5824 27.3192C21.3591 27.0734 20.3774 26.7526 19.582 26.3705C20.3887 28.1446 21.8677 29.6027 25.6198 30.3567C33.7228 31.9854 40.0009 24.3084 40.0009 16.8476C40.0009 12.67 37.9515 9.32471 34.7706 6.97144Z",
    fill: "#E5D6C1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.162 30.9908C26.9113 31.051 25.6592 30.8175 24.5099 30.2442C23.7316 29.8562 22.9957 29.3095 22.4972 28.5376C21.9547 27.6982 21.7322 26.6615 21.5002 25.6593C21.0065 23.5273 20.401 21.3839 19.2729 19.5775C17.6069 16.9092 14.9445 15.2152 12.21 14.093C11.247 13.698 10.2475 13.3531 9.41333 12.6857C8.57948 12.0186 7.92351 10.9417 8.00721 9.80013C8.11474 8.33328 9.34893 7.30512 10.5528 6.70489C13.8686 5.05147 17.7051 4.81011 21.2834 5.11102C24.9315 5.41763 28.8304 6.16357 32.0697 8.14482C35.2689 10.1017 37.6431 13.4807 37.9626 17.5937C38.2766 21.6401 36.5919 26.0065 33.7779 28.5845C32.2039 30.0263 30.1849 30.8929 28.162 30.9908Z",
    fill: "#FC4E51"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.2889 16.2909C37.0153 13.1359 35.1847 10.48 32.6224 8.73425C33.4964 10.051 34.0644 11.5621 34.2069 13.209C34.511 16.7177 32.8803 20.5039 30.1563 22.7394C28.6325 23.9896 26.678 24.7413 24.7197 24.8259C23.676 24.8712 22.6315 24.7262 21.6504 24.3673C21.8094 24.8701 22.0102 25.3546 22.3175 25.7806C22.8001 26.45 23.5126 26.9238 24.266 27.2605C25.3783 27.7576 26.5907 27.9601 27.8014 27.9076C29.7597 27.823 31.7141 27.0715 33.2379 25.821C35.962 23.5856 37.5929 19.7994 37.2889 16.2909Z",
    fill: "#EA3942"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.8653 10.3494C20.8653 11.601 19.8504 12.6159 18.5985 12.6159C17.3469 12.6159 16.332 11.601 16.332 10.3494C16.332 9.0975 17.3469 8.08264 18.5985 8.08264C19.8504 8.08264 20.8653 9.0975 20.8653 10.3494Z",
    fill: "#F3E8D7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.60257 8.35762C9.24991 8.35652 8.95712 8.36751 8.71652 8.38673C8.49048 8.71248 8.33804 9.07695 8.29492 9.48015C8.4707 9.47658 8.68796 9.46971 8.95575 9.4601C11.5213 9.42577 14.4058 9.92811 15.7829 10.2036C15.9746 10.2459 16.157 10.2838 16.332 10.3187C16.3372 9.93031 16.4399 9.56584 16.6168 9.24806C16.438 9.20796 16.2509 9.16869 16.0557 9.13051C14.7708 8.86986 12.1393 8.40211 9.60257 8.35762Z",
    fill: "#912C2C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.6714 25.442C33.3185 25.2038 32.8301 24.8462 32.5217 24.2999C32.2242 23.7729 32.021 23.0837 31.7535 22.2109C31.3907 21.0268 30.9391 19.553 30.0599 17.7523C29.2211 16.0341 27.6624 14.5768 26.0494 13.429C27.2573 12.7245 30.1624 11.4053 34.7335 11.5835C34.7335 11.5835 35.0947 11.5978 35.563 11.6107C35.2927 11.224 34.9966 10.854 34.6758 10.5041C34.1856 10.4769 33.7222 10.4626 33.7222 10.4626C28.8542 10.4964 25.978 12.1194 25.0411 12.7527C23.5868 11.8324 22.202 11.1743 21.3783 10.8142C21.1915 10.7379 21.016 10.6695 20.8498 10.6071C20.8078 10.979 20.6762 11.3234 20.4766 11.6184C20.6359 11.6953 20.8051 11.7728 20.9839 11.8502C22.8238 12.6668 27.4853 14.9951 29.0679 18.2366C29.9089 19.9595 30.3461 21.3872 30.6977 22.5341C30.9663 23.4109 31.1981 24.1651 31.5329 24.7951C31.7903 25.2796 32.1556 25.6979 32.5945 26.0273C32.6522 26.0706 32.7156 26.1179 32.7826 26.1679C32.9375 26.0566 33.09 25.9418 33.2372 25.821C33.3855 25.6996 33.5297 25.5724 33.6714 25.442Z",
    fill: "#912C2C"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_641_280",
    x: 0,
    y: 0,
    width: 44,
    height: 44,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_641_280"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_641_280",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_641_280"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    fill: "white",
    transform: "translate(4)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMeat);
export default __webpack_public_path__ + "static/media/meat.872240739ff40d175b026e55915fc2d9.svg";
export { ForwardRef as ReactComponent };